<template>
  <div class="maincontent">
    <img
      class="maincontent__img"
      v-if="showLogo"
      src="../assets/logo_zbc.svg"
    />
    <h2 class="maincontent__title">{{ title }}</h2>
    <div class="maincontent__information">
      <button class="chevron__wrapper" @click="goBack">
        <img class="chevron--previous" src="../assets/chevron.svg" />
      </button>
      <div class="maincontent__text">
        <transition name="slide-left" mode="out-in">
          <p :key="textValue">
            {{ textValue }}
          </p>
        </transition>
      </div>
      <button class="chevron__wrapper" @click="goNext">
        <img class="chevron--next" src="../assets/chevron.svg" />
      </button>
    </div>
    <transition name="slide-up" mode="out-in">
      <Logos :current="current"></Logos>
    </transition>
  </div>
</template>

<script>
import Logos from "./Logos.vue";
import { EventBus } from "../main.js";

export default {
  name: "Content",
  components: {
    Logos
  },
  data() {
    return {
      titles: ["Wat is het ZBC?", "Werkwijze", "Bewind", "Leden"],
      texts: [
        "Het Zeeuws Bewindvoerders Collectief is opgericht in 2017 met als doel een samenwerkingsverband op te zetten voor Zeeuwse professionele bewindvoerders van diverse pluimage. Alle deelnemende organisaties van het collectief voeren beschermingsbewind, enkele ook budgetbegeleiding.",
        "De bewindvoerders werken volledig zelfstandig op een geheel eigen manier in het eigen bedrijf en ondersteunen elkaar daar waar mogelijk. Zij werken allen vanuit dezelfde integriteit en gedragsregels. Alle bewindvoerders werken volgens de door de rechtbank opgelegde maatstaven en zijn toegelaten als bewindvoerder en voldoen aan alle daaraan gestelde kwaliteitseisen.",
        "“Als iemand wegens omstandigheden niet goed voor zijn financiën kan zorgen, kan de kantonrechter op verzoek een beschermingsmaatregel nemen. Wanneer zo’n maatregel alleen over financiën gaat, is er sprake van bewind”",
        "Verschillende zeeuwse bewindvoerders zijn aangesloten bij het collectief. Klik hieronder op de leden, om meer informatie te krijgen."
      ],
      title: "Wat is het ZBC?",
      current: 0,
      textValue: "",
      showLogo: true,
      showText: true
    };
  },
  methods: {
    goNext() {
      this.showText = false;
      if (this.current > 2) {
        this.title = this.titles[0];
        this.textValue = this.texts[0];
        this.current = 0;
      } else {
        this.title = this.titles[this.current + 1];
        this.textValue = this.texts[this.current + 1];
        this.current += 1;
      }
      this.showText = true;
    },
    goBack() {
      if (this.current - 1 < 0) {
        this.title = this.titles[3];
        this.textValue = this.texts[3];
        this.current = 3;
      } else {
        this.title = this.titles[this.current - 1];
        this.textValue = this.texts[this.current - 1];
        this.current -= 1;
      }
    },
    toggleCompanyInfo(event) {
      let clickedEl = event.target;

      if (clickedEl.classList.contains("logo")) {
        let el = clickedEl.parentElement.getElementsByClassName(
          "maincontent__company-info"
        )[0];
        el.classList.add("-open");
      } else if (clickedEl.classList.contains("maincontent__btn--close")) {
        let el = event.target.parentElement;
        el.classList.remove("-open");
      } else {
        let el = event.target.parentElement.parentElement;
        el.classList.remove("-open");
      }
    }
  },
  mounted() {
    EventBus.$on("navigate", payload => {
      this.title = this.titles[payload];
      this.textValue = this.texts[payload];
      this.current = payload;
    });
  },
  created() {
    this.textValue = this.texts[0];
  }
};
</script>

<style scoped lang="scss">
@import "../assets/scss/style.scss";

.maincontent {
  margin-top: 3rem;
}

.maincontent__img {
  display: none;

  @media only screen and (min-width: 1024px) {
    width: 28rem;
    position: absolute;
    left: 1rem;
    top: 9rem;
    display: block;
    opacity: 0.15;
    z-index: 1000;
  }
}

.maincontent__information {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  @media only screen and (min-width: 1024px) {
    justify-content: center;
  }
}

.maincontent__text {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  overflow-x: hidden;

  p {
    margin: 0 0.2rem;
    max-width: 36rem;

    @media only screen and (min-width: 1024px) {
      margin: 0 2rem;
      max-width: 42rem;
    }
  }

  @media only screen and (min-width: 1024px) {
    width: 65%;
  }
}

.chevron__wrapper {
  min-width: 3rem;
  z-index: 1001;
}

.chevron--previous,
.chevron--next {
  height: 5rem;
}

.chevron--next {
  transform: rotate(180deg);
}

.slide-left-enter-active {
  transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1);
}
.slide-left-leave-active {
  transition: transform 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-left-enter {
  transform: translateX(42rem);
}

.slide-left-leave-to {
  transform: translateX(-42rem);
}

.slide-up-enter-active {
  transition: transform 0.5s ease;
}

.slide-up-leave-active {
  transition: all 0.5s ease;
}

.slide-up-leave-to {
  transform: translateY(-20rem);
}

.slide-up-enter {
  transform: translateY(10rem);
}
</style>
